module.exports = () ->
  return {
    restrict: 'A'
    scope:
      completed: '&'
      autoCompleted: '&?'
      notApplicable: '&?'
    template: require('./completion-indicator.html')
    controller: ($scope) ->
      @tooltips =
        not_applicable: "Not applicable"
        auto_completed: "Automatically completed"
        completed: "Completed"
        incomplete: "Incomplete"

      @classes =
        not_applicable: "glyphicon-ban-circle"
        auto_completed: "glyphicon-expand"
        completed: "glyphicon-check"
        incomplete: "glyphicon-unchecked"

      $scope.getIndicatorStatus = () ->
        if $scope.notApplicable()
          return "not_applicable"
        else if $scope.autoCompleted()
          return "auto_completed"
        else if $scope.completed()
          return "completed"
        else
          return "incomplete"

      $scope.getIndicatorTooltip = () =>
        @tooltips[$scope.getIndicatorStatus()]

      $scope.getIndicatorClass = () =>
        @classes[$scope.getIndicatorStatus()]
  }
